import { iconFor } from '../folders/FolderIcons';

/** The nook's glyph, drawn from the app's own drawable: faint beside a label
 *  or in a row, larger in [ink] where it leads a card or a page head. */
export function NookGlyph({ size = 13, ink = 'var(--inkFaint)' }: { size?: number; ink?: string }) {
  const Icon = iconFor('nook');
  if (!Icon) return null;
  return (
    <span className="nook-glyph" style={{ display: 'inline-flex', flex: 'none', color: ink }}>
      <Icon size={size} />
    </span>
  );
}
